declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1299609178999376'

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  window.fbq = n
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Defer the Meta Pixel script so it does not block the main thread / LCP.
  // Inject after the browser is idle (or after a short timeout fallback).
  const inject = () => {
    const script = document.createElement('script')
    script.async = true
    script.defer = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const target = document.head || document.body || document.documentElement
    if (target) {
      target.appendChild(script)
    }
  }

  const ric = (window as any).requestIdleCallback as
    | ((cb: () => void, opts?: { timeout: number }) => number)
    | undefined
  if (typeof ric === 'function') {
    ric(inject, { timeout: 2000 })
  } else {
    setTimeout(inject, 1500)
  }

  window.fbq('init', PIXEL_ID)
}

export function trackPageView(): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'PageView')
}

export function trackViewContent(params?: {
  content_name?: string
  content_category?: string
  value?: number
  currency?: string
}): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq(
    'track',
    'ViewContent',
    params ?? {
      content_name: 'Código Hormonal 40+',
      content_category: 'Programa Digital',
      value: 17,
      currency: 'USD',
    },
  )
}

export function trackAddToCart(params?: {
  content_name?: string
  content_category?: string
  value?: number
  currency?: string
}): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq(
    'track',
    'AddToCart',
    params ?? {
      content_name: 'Código Hormonal 40+',
      content_category: 'Programa Digital',
      value: 17,
      currency: 'USD',
    },
  )
}
